export const CustomCloseButton = ({ closeToast }: any) => (
    <span
      style={{ color: "#00D400", cursor: "pointer", fontSize: "13px", marginRight: "12px"}}
      onClick={closeToast}
    >
      CLOSE
    </span>
  );